import { render, staticRenderFns } from "./recyclable.vue?vue&type=template&id=2a23f2da&scoped=true&"
import script from "./recyclable.vue?vue&type=script&lang=js&"
export * from "./recyclable.vue?vue&type=script&lang=js&"
import style0 from "./recyclable.vue?vue&type=style&index=0&id=2a23f2da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a23f2da",
  null
  
)

export default component.exports